/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Button,
	Center,
	Divider,
	Flex,
	Heading,
	HStack,
	Icon,
	IconButton,
	List,
	ListItem,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Spinner,
	Text,
	VStack,
	FormControl,
	FormLabel,
	useDisclosure,
	ModalHeader,
	Switch,
	FormErrorMessage,
	Grid,
	GridItem,
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState, useCallback } from 'react'
import { FiUploadCloud } from 'react-icons/fi'
import { MdCheck, MdClose } from 'react-icons/md'
import { VscFolder } from 'react-icons/vsc'
import { useAuthContext } from '../../../../context/auth.context'
import { useSharedContext } from '../../../../context/shared.context'
import {
	useAddTimelineUpdate,
	useLoadActivityParticipant,
} from '../../../../hooks/activity.hooks'
import { sharedConst } from '../../../../utils/action.constant'
import { pushFileToS3 } from '../../../../utils/aws.util'
import { useDropzone } from 'react-dropzone'
import Select from '../../../../components/chakra-react-select'
import {
	eventLabelTrack,
	GA_CATEGORY_WORKSPACE_PANEL,
	sectionDetailedTrack,
} from './../../../repository/repo.utils'
import { useLanguageContext } from '../../../../context/locale.context'
import SVGIcon from '../../../../assets/svgIcons'

// TODO: Implement the congnito based document upload

const TimelineUploads = ({
	activity,
	isOpen,
	onClose,
	fileAccessTyp,
	fileList,
	setfileList,
	completedList,
	setcompletedList,
}) => {
	const inputRef = useRef()
	const [isError, setisError] = useState(false)
	const [isLoading, setisLoading] = useState(false)
	const [data, setdata] = useState([])
	const [selectedParticipant, setSelectedParticipant] = useState([])
	const [disableUpload, setdisableUpload] = useState(false)

	const [uploadingFile, setuploadingFile] = useState(null)
	const [participentError, setparticipentError] = useState('')
	const [isAccess, setIsAccess] = useState(false)
	const { mutate } = useAddTimelineUpdate()
	const { mutate: participantList } = useLoadActivityParticipant()
	const { dispatch } = useSharedContext()
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		asset_id,
		operating_asset_first_name,
		organization_flag_enable_attachment_access_control,
	} = authData
	const { activity_id, activity_type_id, activity_type_category_id } =
		activity || {}

	useEffect(() => {
		loadParticipants()
	}, [])

	const loadParticipants = useCallback(() => {
		participantList(
			{ activity_id },
			{
				onSuccess: async data => {
					let finalData = []
					if (data.list && data.list.length > 0) {
						finalData = data.list.filter(val => val.asset_id !== asset_id)
					}
					setdata(finalData || [])
				},
			}
		)
	})

	const onHandleFileChange = (selectedfiles, rejectedFiles) => {
		setisError(false)
		setdisableUpload(false)
		if (
			fileList.length + selectedfiles.length > 5 ||
			(rejectedFiles && rejectedFiles.length > 5)
		) {
			return setdisableUpload(true)
		}
		const files = [...selectedfiles].filter(file => {
			if (file.name.split('.').length > 2) {
				return false
			}
			return true
		})

		if (files.length === 0) {
			setisError(true)
		} else if (
			selectedfiles[0].name.split('.').pop() === 'exe' ||
			selectedfiles[0].name.split('.').pop() === 'php' ||
			selectedfiles[0].name.split('.').pop() === 'sh' ||
			selectedfiles[0].name.split('.').pop() === 'py'
		) {
			setisError(true)
		} else {
			setfileList([...fileList, ...files])
		}
		onClose()
	}

	const removeFile = file => {
		let files = fileList.filter(
			f => f.name.toLowerCase() !== file.name.toLowerCase()
		)
		setfileList(files)
	}

	const fileSizeFormatted = size => {
		if (!size || size < 1000) {
			return `${size} Bytes`
		} else if (size < 1000000) {
			return `${Math.floor(size / 1000)}KB`
		} else {
			return `${Math.floor(size / 1000000)}MB`
		}
	}

	const onComment = ({ url }) => {
		let payload = {
			content: [],
			subject: url,
			mail_body: url,
			attachments: [url],
			activity_reference: [],
			asset_reference: [],
			form_approval_field_reference: [],
			is_reply: 0,
			flag_attachment_access_restricted: !!fileAccessTyp
				? organization_flag_enable_attachment_access_control
				: 0,
			doc_access_participants: [
				...selectedParticipant.map(p => ({
					asset_id: p.value,
					asset_name: p.label,
				})),
				organization_flag_enable_attachment_access_control === 1 && {
					asset_id: asset_id,
					asset_name: operating_asset_first_name,
				},
			],
		}
		mutate({
			operating_asset_first_name,
			activity_id,
			activity_type_category_id,
			activity_type_id,
			// data_entity_inline: JSON.stringify(payload),
			activity_timeline_collection: JSON.stringify(payload),
		})
	}

	const onUpload = async () => {
		setparticipentError('')
		if (!!fileAccessTyp && selectedParticipant.length === 0) {
			setparticipentError('required')
			return
		}

		eventLabelTrack({
			categoryId: 0,
			actionId: 5,
			label: `Uploading Files in Timeline`,
		})

		setisLoading(true)
		const urlPromises = fileList.map(async file => {
			setuploadingFile(file)
			const blob = file.slice(0, file.size, file.type)
			const newFile = new File([blob], file.name.replace(/ /gi, '-'), {
				type: blob.type,
			})
			let result = await pushFileToS3(newFile)
			setuploadingFile(null)
			setcompletedList([...completedList, file.name])
			return result
		})
		const urls = await Promise.all(urlPromises)
		const commentPs = urls.map(async item => await onComment(item))
		await Promise.all(commentPs)
		setisLoading(false)
		setTimeout(() => {
			dispatch({
				type: sharedConst.REFRESH_TIMELINE,
			})
			onClose()
		}, 500)
	}

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop: onHandleFileChange,
		maxFiles: 5,
		onClose,
		accept: 'image/*',
	})
	let {
		getRootProps: vr,
		getInputProps: vi,
		isDragActive: vd,
	} = useDropzone({
		onDrop: onHandleFileChange,
		maxFiles: 5,
		onClose,
		accept: 'video/mp4,video/x-m4v,video/*',
	})
	let {
		getRootProps: dr,
		getInputProps: di,
		isDragActive: dd,
	} = useDropzone({
		onDrop: onHandleFileChange,
		maxFiles: 5,
		onClose,
		accept: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf',
	})
	let {
		getRootProps: allr,
		getInputProps: alli,
		isDragActive: alld,
	} = useDropzone({
		onDrop: onHandleFileChange,
		maxFiles: 5,
		onClose,
	})

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={'20px'} mt='30vh'>
				<ModalHeader fontSize={'16px'} fontWeight='500' fontStyle={'normal'}>
					{locale['Attachments']}
				</ModalHeader>
				<ModalCloseButton color={'#EF3D3D'} />
				<Divider />
				<ModalBody>
					<Flex>
						<Box
							w='50%'
							h='5rem'
							borderRight={'1px solid #E1E1E1'}
							borderBottom={'1px solid #E1E1E1'}
							borderLeft={'1px solid #E1E1E1'}
						>
							<Center>
								<Flex w='20%' h='30%' cursor='pointer' {...getRootProps()}>
									<VStack w='100%' alignItems='center'>
										<SVGIcon
											iconName='PhotoSvg'
											svgProps={{
												width: '48',
												height: '48',
												viewBox: '0 0 48 48',
											}}
										/>
										<Text
											color='#000000'
											fontSize='14px'
											fontWeight={500}
											textAlign='center'
											mt='-3'
										>
											{'Image'}
										</Text>
										<input
											type='file'
											{...getInputProps()}
											name='file'
											// ref={inputRef}
											// style={{ display: 'none' }}
											// disabled={disableUpload}
										></input>
									</VStack>
								</Flex>
							</Center>
						</Box>
						<Box
							w='50%'
							borderRight={'1px solid #E1E1E1'}
							borderBottom={'1px solid #E1E1E1'}
						>
							<Center>
								<Flex w='20%' h='30%' cursor='pointer' {...vr()}>
									<VStack w='100%' alignItems='center'>
										<SVGIcon
											iconName='VideoSvg'
											svgProps={{
												width: '44',
												height: '44',
												viewBox: '0 0 44 44',
											}}
										/>
										<Text
											color='#000000'
											fontSize='14px'
											fontWeight={500}
											textAlign='center'
											mt='-3'
										>
											{'Video'}
										</Text>
										<input
											type='file'
											// accept={acceptedFileTypes}

											name='file'
											ref={inputRef}
											style={{ display: 'none' }}
											// disabled={disableUpload}
											{...vi()}
										></input>
									</VStack>
								</Flex>
							</Center>
						</Box>
					</Flex>
					<Flex>
						<Box
							w='50%'
							h='6rem'
							borderRight={'1px solid #E1E1E1'}
							borderBottom={'1px solid #E1E1E1'}
							borderLeft={'1px solid #E1E1E1'}
						>
							<Center>
								<Flex w='20%' h='30%' cursor='pointer' {...dr()}>
									<VStack w='100%' alignItems='center' mt='2'>
										<SVGIcon
											iconName='DocumentSvg'
											svgProps={{
												width: '40',
												height: '40',
												viewBox: '0 0 40 40',
											}}
										/>
										<Text
											color='#000000'
											fontSize='14px'
											fontWeight={500}
											textAlign='center'
											mt='-3'
										>
											{'Documents'}
										</Text>
										<input
											type='file'
											// accept={acceptedFileTypes}

											name='file'
											ref={inputRef}
											style={{ display: 'none' }}
											// disabled={disableUpload}
											{...di()}
										></input>
									</VStack>
								</Flex>
							</Center>
						</Box>
						<Box
							w='50%'
							h='6rem'
							borderRight={'1px solid #E1E1E1'}
							borderBottom={'1px solid #E1E1E1'}
						>
							<Center>
								<Flex w='20%' h='30%' cursor='pointer' {...allr()}>
									<VStack w='100%' alignItems='center' mt='2'>
										<IconButton
											color='brand.700'
											bg='#FFFFFF'
											_hover={{
												bg: '',
											}}
											icon={<Icon as={VscFolder} w={'40px'} h={'40px'} />}
										/>
										<Text
											color='#000000'
											fontSize='14px'
											fontWeight={500}
											textAlign='center'
											mt='-3'
										>
											{'All'}
										</Text>
										<input
											type='file'
											// accept={acceptedFileTypes}

											name='file'
											ref={inputRef}
											style={{ display: 'none' }}
											// disabled={disableUpload}
											{...alli()}
										></input>
									</VStack>
								</Flex>
							</Center>
						</Box>
					</Flex>
					{disableUpload ? (
						<Text color='red' fontSize='10px' textAlign='center' px={5}>
							{locale['Max 5 file can be uploaded at time']}
						</Text>
					) : null}
				</ModalBody>
				{/* <ModalFooter>
					<Button colorScheme='blue' mr={3} onClick={onClose}>
						Close
					</Button>
					<Button variant='ghost'>Secondary Action</Button>
				</ModalFooter> */}
			</ModalContent>
		</Modal>
	)
}

export default TimelineUploads
